export default __webpack_public_path__ + "static/amazonFires1-5e9f47f6c5e5956141c8336014f5678b.gif";